import ActivityTracker from "./ActivityTracker";

export class IndexedTracker {
	public index: number;
	public surveyId: string;
	public tracker: ActivityTracker;
}
